var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceMeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.959,
    height: 50.392,
    viewBox: "0 0 60.959 50.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38708",
    "data-name": "\\uADF8\\uB8F9 38708",
    transform: "translate(1.202 1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    "data-name": "\\uD328\\uC2A4 25",
    d: "M97.7,1963.93a23.251,23.251,0,0,1-43.241,7.37",
    transform: "translate(-45.219 -1935.263)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_26",
    "data-name": "\\uD328\\uC2A4 26",
    d: "M72.59,1869.642a23.25,23.25,0,0,1,35.177,5.18",
    transform: "translate(-58.434 -1862.304)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1",
    "data-name": "\\uD0C0\\uC6D0 1",
    cx: 15.403,
    cy: 15.403,
    r: 15.403,
    transform: "translate(14.157 9.344)",
    fill: "none",
    stroke: "#000c7a",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_2",
    "data-name": "\\uD0C0\\uC6D0 2",
    cx: 15.403,
    cy: 15.403,
    r: 15.403,
    transform: "translate(14.157 9.344)",
    fill: "none",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27",
    "data-name": "\\uD328\\uC2A4 27",
    d: "M211.46,1905.123v-46.851s-9.225.813-9.225,12.518v16.149h4.613v18.184Z",
    transform: "translate(-152.904 -1858.272)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_28",
    "data-name": "\\uD328\\uC2A4 28",
    d: "M20.416,1858.272v12.722s-.174,6.4,4.705,6.4v27.732h4.531v-27.732c4.88,0,4.705-6.4,4.705-6.4v-12.722",
    transform: "translate(-20.415 -1858.272)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_15",
    "data-name": "\\uC120 15",
    y2: 11.984,
    transform: "translate(9.76 0)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_16",
    "data-name": "\\uC120 16",
    y2: 11.984,
    transform: "translate(4.88 0)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceMeal);
export default __webpack_public_path__ + "static/media/icon-service-meal.2d75c345440c1c22a19b114e090788cf.svg";
export { ForwardRef as ReactComponent };